export default "__VITE_ASSET__BES_ne6e__"